/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimUpdateRequestDto } from '../models/clm-claim-update-request-dto';
import { ClmExternalClaimResponseDto } from '../models/clm-external-claim-response-dto';


/**
 * the ClaimUpdate API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaimUpdateService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimUpdateCommand
   */
  static readonly ClaimUpdateCommandPath = '/claim/update';

  /**
   * Update claim data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimUpdateCommand()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claimUpdateCommand$Response(params: {
    tpaCode?: string;
    body: ClmClaimUpdateRequestDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmExternalClaimResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaimUpdateService.ClaimUpdateCommandPath, 'put');
    if (params) {
      rb.query('tpaCode', params.tpaCode, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmExternalClaimResponseDto>;
      })
    );
  }

  /**
   * Update claim data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimUpdateCommand$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claimUpdateCommand(params: {
    tpaCode?: string;
    body: ClmClaimUpdateRequestDto
  },
  context?: HttpContext

): Observable<ClmExternalClaimResponseDto> {

    return this.claimUpdateCommand$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmExternalClaimResponseDto>) => r.body as ClmExternalClaimResponseDto)
    );
  }

}
